module.exports = __webpack_public_path__ + "img/mobile_t8.09ab1fae.png";